import React from 'react';

import { Button, Modal, Typography } from 'antd';

import styled from '@/styled';

interface IProps {
  handleRefuseInvite: () => void;
  setOpen: () => void;
  open: boolean;
  isLoading: boolean;
}

const ConfirmRefuse: React.FC<IProps> = ({ isLoading, open, handleRefuseInvite, setOpen }) => {
  return (
    <Modal
      open={open}
      onOk={handleRefuseInvite}
      onCancel={setOpen}
      footer={[
        <Button key='back' onClick={setOpen} type='ghost' disabled={isLoading}>
          Não
        </Button>,
        <Button key='submit' onClick={handleRefuseInvite} type='primary' loading={isLoading}>
          Sim
        </Button>
      ]}
      style={{ minHeight: '200px' }}
      closable={false}
      title='Recusar convite'
      centered
      zIndex={1500}
    >
      <Typography.Paragraph>Tem certeza que deseja recusar esse convite?</Typography.Paragraph>
    </Modal>
  );
};

export default styled(ConfirmRefuse)``;
